import React from 'react'
import { StyleSheet, SafeAreaView } from 'react-native'
import ProductList from '../../components/ProductList'
import { useAtomValue } from 'jotai'
import { allProductsByCategoryListAtom } from '../../global/AtomsProvider'

export default function AddProductStickerScreen( { navigation, route } ) {
  const { getClientsByProduct } = route.params
  const allProductsByCategoryList = useAtomValue(allProductsByCategoryListAtom)

  const onItemPress = (item, index, store) => {
    getClientsByProduct(item)
    navigation.goBack()
  }

  return (
    <SafeAreaView style={styles.container}>
      <ProductList preselectedStore='all' products={allProductsByCategoryList} onItemPress={onItemPress} />
    </SafeAreaView>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'stretch',
  }, 
});
